import api from '@/api'
import config from '@/config'
import { NotificationRequest, NotificationResponse } from '@/types/notifications/Notification'

class NotificationService {
  _endpoint = 'notifications'

  async sendNotification (notification: NotificationRequest): Promise<NotificationResponse> {
    return api.post(`${config.apiFillsUrl}${this._endpoint}`, notification)
  }
}

export default new NotificationService()
